export default __webpack_public_path__ + "static/media/Ted.fb598148.png";